var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerPage",attrs:{"id":"userList"}},[_vm._v(" 用户详情 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }